<template>
  <b-card class="card-stats" :show-footer-line="true">
    <b-row align-v="center" class="row">

      <div class="col">
        <slot>
          <h5 class="card-title text-uppercase text-muted mb-0" v-if="title">{{title}}</h5>
          <span class="h2 font-weight-bold mb-0" v-if="subTitle">{{subTitle}}</span>
        </slot>
      </div>

      <div class="col-auto" v-if="$slots.icon || icon">
        <slot name="icon">
          <b-button @click="cardClicked" class="icon icon-shape text-white rounded-circle shadow"
               :class="[`bg-${type}`, iconClasses]">
            <i :class="icon"></i>
          </b-button>
        </slot>
      </div>
    </b-row>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </b-card>
</template>
<script>

export default {
  components: {
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    icon: String,
    linkUrl: String,
    title: String,
    subTitle: String,
    iconClasses: [String, Array],
  },
  methods: {
    cardClicked() {
      console.info('stat card clicked');
      if (this.linkUrl && this.linkUrl !== '') {
        this.$router.push(this.linkUrl);
      }
    },
  },
};
</script>
<style></style>
